import React from 'react';
import { makeStyles } from '@mui/styles';
import clsx from "clsx";

function Separator({
    isMainSeparator
}) {
    const classes = useStyles();

    return (
            <hr className={clsx(classes.separator,isMainSeparator? classes.mainSeparator : undefined)}/>
    );
}

const useStyles = makeStyles({
    separator: {
        borderWidth: '1px 0 0 0',
        borderColor: '#E1E5E9',
        borderStyle: 'solid'
    },
    mainSeparator: {
        marginTop: '16px',
        marginBottom: '10px'
    }
})

export default React.memo(Separator);